import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  input,
  type TemplateRef,
} from '@angular/core';
import { CustomMatSvgIconDirective } from '@pct-ng/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { MatCard, MatCardContent } from '@angular/material/card';
import { NgTemplateOutlet } from '@angular/common';
import { outputFromObservable } from '@angular/core/rxjs-interop';
import { Subject } from 'rxjs';
import { MatSuffix } from '@angular/material/form-field';
import { ControlErrorComponent } from '@pct-ng/form';
import { IsNilPipe } from '@pct-ng/common/pipe';

@Component({
  selector: 'cappus-list-filter-panel-wrapper',
  imports: [
    CustomMatSvgIconDirective,
    TranslocoDirective,
    MatFormField,
    MatLabel,
    ReactiveFormsModule,
    MatIconButton,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatInput,
    MatIcon,
    MatCardContent,
    MatCard,
    NgTemplateOutlet,
    MatSuffix,
    MatIconButton,
    ControlErrorComponent,
    IsNilPipe,
  ],
  templateUrl: './list-filter-panel-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListFilterPanelWrapperComponent {
  protected readonly isExpandedFilterPanelChange$ = new Subject<boolean>();

  readonly i18nPrefix = input.required<string>();
  readonly isExpandedFilterPanel = input.required<boolean>();
  readonly searchTextControl = input.required<FormControl<string | null>>();
  readonly isExpandedFilterPanelChange = outputFromObservable(this.isExpandedFilterPanelChange$);

  protected readonly buttonsTemplateRef = contentChild<TemplateRef<any>>('buttons');
  protected readonly filtersTemplateRef = contentChild<TemplateRef<any>>('filters');
}
